import { ProSchemaValueEnumObj } from '@ant-design/pro-components';

export const DEFAULT_NAME = 'Umi Max';

export const DEFAULT_TIME_ZONE = 'America/New_York'; //EST

export enum SponsorStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum UserAuthority {
  ADMINISTRATOR = 'ADMINISTRATOR',
  USER = 'USER',
  STREAMER = 'STREAMER',
}

export enum ObtainedItemStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
}

export enum RaffleType {
  GIVEAWAY = 'GIVEAWAY',
  RAFFLE = 'RAFFLE',
  LOTTO = 'LOTTO'
}

// export enum GiveawayCategory {
//   NONE = 'NONE',
//   SHUFFLE = 'SHUFFLE',
//   RUNESCAPE = 'RUNESCAPE',
// }

export enum RaffleStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  UPCOMING = 'UPCOMING',
}

export enum LottoStatus {
  PENDING = 'PENDING',
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED'
}

export enum GiveawayStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  UPCOMING = 'UPCOMING',
}

export enum WagerRequirementType {
  MONTHLY = 'MONTHLY',
  TOTAL = 'TOTAL',
}

export enum JoinRequirementsType {
  BET = 'BET',
  SUBSCRIPTION = 'SUBSCRIPTION',
  WAGER = 'WAGER',
}

export enum RewardStatus {
  PENDING = 'PENDING',
  REWARDED = 'REWARDED',
}

export enum BanUserType {
  ENTIRE_ACCOUNT = 'ENTIRE_ACCOUNT',
  RAFFLES = 'RAFFLES',
  GIVEAWAYS = 'GIVEAWAYS',
  GAME_ID = 'GAME_ID',
}

export enum BountyStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum BountySubmissionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum ChallengeSponsor {
  SHUFFLE = 'SHUFFLE',
  LUXDROP = 'LUXDROP',
}

export const OBTAINED_ITEM_STATUS: ProSchemaValueEnumObj = {
  [ObtainedItemStatus.COMPLETED]: { text: 'Completed', status: 'Success' },
  [ObtainedItemStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [ObtainedItemStatus.CANCELLED]: { text: 'Cancelled', status: 'Error' },
};

export const SPONSOR_STATUS: ProSchemaValueEnumObj = {
  [SponsorStatus.ACTIVE]: { text: 'Active', status: 'Success' },
  [SponsorStatus.INACTIVE]: { text: 'Inactive', status: 'Error' },
};

export const USER_AUTHORITY: ProSchemaValueEnumObj = {
  [UserAuthority.ADMINISTRATOR]: {
    text: 'Administrator',
    status: 'Success',
  },
  [UserAuthority.USER]: { text: 'User', status: 'Success' },
  [UserAuthority.STREAMER]: { text: 'Streamer', status: 'Success' },
};

export const RAFFLE_STATUS: ProSchemaValueEnumObj = {
  [RaffleStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [RaffleStatus.ACTIVE]: { text: 'Active', status: 'Success' },
  [RaffleStatus.COMPLETED]: { text: 'Completed', status: 'Default' },
  [RaffleStatus.UPCOMING]: { text: 'Upcoming', status: 'Processing' },
};

export const LOTTO_STATUS: ProSchemaValueEnumObj = {
  [LottoStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [LottoStatus.UPCOMING]: { text: 'Upcoming', status: 'Processing' },
  [LottoStatus.ACTIVE]: { text: 'Active', status: 'Success' },
  [LottoStatus.ENDED]: { text: 'Ended', status: 'Default'}
}

export const GIVEAWAY_STATUS: ProSchemaValueEnumObj = {
  [GiveawayStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [GiveawayStatus.ACTIVE]: { text: 'Active', status: 'Success' },
  [GiveawayStatus.COMPLETED]: { text: 'Completed', status: 'Default' },
  [GiveawayStatus.UPCOMING]: { text: 'Upcoming', status: 'Processing' },
};

export const REWARD_STATUS: ProSchemaValueEnumObj = {
  [RewardStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [RewardStatus.REWARDED]: { text: 'Rewarded', status: 'Success' },
};

export const BOUNTY_STATUS: ProSchemaValueEnumObj = {
  [BountyStatus.PENDING]: {
    text: 'Pending',
    status: 'Warning',
    color: 'warning',
  },
  [BountyStatus.ACTIVE]: {
    text: 'Active',
    status: 'Success',
    color: 'success',
  },
  [BountyStatus.COMPLETED]: {
    text: 'Completed',
    status: 'Default',
    color: 'default',
  },
  [BountyStatus.EXPIRED]: { text: 'Expired', status: 'Error', color: 'error' },
};

export const BOUNTY_SUBMISSION_STATUS: ProSchemaValueEnumObj = {
  [BountySubmissionStatus.PENDING]: { text: 'Pending', status: 'Warning' },
  [BountySubmissionStatus.APPROVED]: { text: 'Approved', status: 'Success' },
  [BountySubmissionStatus.REJECTED]: { text: 'Rejected', status: 'Error' },
};

export const GIVEAWAY_STATUS_OPTIONS = [
  {
    label: 'Pending',
    status: 'warning',
    value: GiveawayStatus.PENDING,
  },
  {
    label: 'Active',
    status: 'success',
    value: GiveawayStatus.ACTIVE,
  },
  {
    label: 'Completed',
    status: 'default',
    value: GiveawayStatus.COMPLETED,
  },
  {
    label: 'Upcoming',
    status: 'processing',
    value: GiveawayStatus.UPCOMING,
  },
];

export const RAFFLE_STATUS_OPTIONS = [
  {
    label: 'Pending',
    status: 'warning',
    value: RaffleStatus.PENDING,
  },
  {
    label: 'Active',
    status: 'success',
    value: RaffleStatus.ACTIVE,
  },
  {
    label: 'Completed',
    status: 'default',
    value: RaffleStatus.COMPLETED,
  },
  {
    label: 'Upcoming',
    status: 'processing',
    value: RaffleStatus.UPCOMING,
  },
];

export const LOTTO_STATUS_OPTIONS = [
  {
    label: 'Pending',
    status: 'warning',
    value: LottoStatus.PENDING,
  },
  {
    label: 'Active',
    status: 'success',
    value: LottoStatus.ACTIVE,
  },
  {
    label: 'Ended',
    status: 'default',
    value: LottoStatus.ENDED,
  },
  {
    label: 'Upcoming',
    status: 'processing',
    value: LottoStatus.UPCOMING,
  },
];

export const JOIN_REQUIREMENTS_TYPE: ProSchemaValueEnumObj = {
  [JoinRequirementsType.BET]: { text: 'Bet', status: 'Success' },
  [JoinRequirementsType.WAGER]: { text: 'Wager', status: 'Success' },
  [JoinRequirementsType.SUBSCRIPTION]: {
    text: 'Subscription',
    status: 'Success',
  },
};

export const WAGER_REQUIREMENT_TYPE: ProSchemaValueEnumObj = {
  [WagerRequirementType.MONTHLY]: {
    text: 'Wager Leaderboard Requirement',
    status: 'Success',
  },
  [WagerRequirementType.TOTAL]: {
    text: 'Overall Total Wager',
    status: 'Success',
  },
};

export const CHALLENGE_SPONSOR_OPTIONS = [
  {
    label: 'Shuffle',
    status: 'success',
    value: ChallengeSponsor.SHUFFLE,
  },
  {
    label: 'Luxdrop',
    status: 'success',
    value: ChallengeSponsor.LUXDROP,
  },
];

export const CHALLENGE_SPONSOR: ProSchemaValueEnumObj = {
  [ChallengeSponsor.SHUFFLE]: { text: 'Shuffle' },
  [ChallengeSponsor.LUXDROP]: { text: 'Luxdrop' },
};
